import Funnel from "../../services/funnel-service.js";

const template = `
<div v-show="fs.display(input)">
        <component :id="input.uid" :class="input.class" :is="input.text_type ? input.text_type : 'span'" v-if="!input.hidden" v-html="fs.parseHtml(computedValue)"></component>
</div>
`;
//<span :id="input.uid" :class="input.class" v-if="!input.hidden && (!input.text_type || input.text_type == '' )">{{computedValue}}</span>
//<p  :id="input.uid" :class="input.class" v-if="!input.hidden && input.text_type == 'p' ">{{computedValue}}</p>
//<h1 :id="input.uid" :class="input.class" v-if="!input.hidden && input.text_type == 'h1' ">{{computedValue}}</h1>
//<h2 :id="input.uid" :class="input.class" v-if="!input.hidden && input.text_type == 'h2' ">{{computedValue}}</h2>
//<h3 :id="input.uid" :class="input.class" v-if="!input.hidden && input.text_type == 'h3'">{{computedValue}}</h3>
//<h4 :id="input.uid" :class="input.class" v-if="!input.hidden && input.text_type == 'h4'">{{computedValue}}</h4>
//<h5 :id="input.uid" :class="input.class" v-if="!input.hidden && input.text_type == 'h5'">{{computedValue}}</h5>
//<h6 :id="input.uid" :class="input.class" v-if="!input.hidden && input.text_type == 'h6'">{{computedValue}}</h6>
//<a :id="input.uid" :class="input.class" v-if="!input.hidden && input.text_type == 'a'">{{computedValue}}</a>
export default {
    name: 'qt-text-inline',
    template,
    props: ['iuid'],
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        computedValue: function(){
            if ((this.input.value && this.input.uid === "in_garage_city") || (this.input.value && this.input.uid === "in_current_city") ) {
                return this.input.value + ', '
            }
            else{
                return this.input.value
            } 
        }
    },
    mounted: function(){
       
    },
    methods: {
        
    }
};
